export const getTaggingsUrl = () => '/agency/taggings';

export const getTaggingContextsUrl = () => '/agency/taggings/contexts';

export const getTaggingUrl = (id: number) => `/agency/taggings/${id}`;
